import styles from '/builds/sitegeist/bad-toelz-de/.build/releases/1/DistributionPackages/BadToelz.BadToelzDe/Resources/Private/Fusion/Presentation/Components/WebPageFoot/WebPageFoot.css';

export const prototypeName = '9rG8pP4b17iG9V7dnMAWT8nrrQDVX2sgzWAWgeXWsAK7RoMApXCRnxqb74dqcXngdrexj6';
export {styles};